module.exports = __webpack_public_path__ + "media/images/badges/rumble/milestone-750-Inactive-Rumble-6a2c57b617986ffcf27080d9041ffd3a.png";